<template>
  <div class="container">
    <van-popup
      v-model="show"
      get-container="body"
      close-on-popstate
      safe-area-inset-bottom
      :overlay-style="overlayStyle"
      :style="{ width:'80%' }"
    >
    <div class="popup-container">
      <div class="title">
        <van-icon name="volume" size="16px" />
        <span style="margin-left:5px">
          {{noticeData.title ? noticeData.title : '节目公告'}}
        </span>
        <span class="date">{{createdFormat}}</span>
      </div>
      <div class="content">
        {{noticeData.content}}
      </div>
      <div style="margin-top:16px;">
        <van-button
          type="default"
          size="small"
          block
          round
          style="font-size:14px;font-weight:bold;"
          @click="closePopup"
        >我知道了</van-button>
      </div>
    </div>
    </van-popup>
    <div class="inner-container" @click="expendNoticebar">
      <div class="title">
        <van-icon name="volume" size="16px" />
        <span style="margin-left:5px">
          {{noticeData.title ? noticeData.title : '节目公告'}}
        </span>
        <span class="date">{{createdFormat}}</span>
      </div>
      <div v-if="scrollable" style="margin-top:8px;">
        <van-notice-bar
          background="#fff"
          color="#a3a3a4"
          style="padding:0;margin:0;line-height:1;height:30px;"
          :text="noticeData.content"
        />        
      </div>
      <div v-else class="van-multi-ellipsis--l2" style="margin-top:8px;">
        {{noticeData.content}}
      </div>
    </div>
  </div>
</template>

<script>
  import { Icon } from 'vant'
  import { Popup } from 'vant'
  import { Button } from 'vant'
  import { NoticeBar } from 'vant'
  import Vue from 'vue'
  Vue.use(Icon, Popup, Button)
  Vue.use(NoticeBar)
  export default {
    name: "ShowNoticeBar",
    components: {
    },
    props: {
      slug: {
        type: String,
        default: 'sanhao'
      },
      noticeData: {
        type: Object,
        default: function () {
          return {
            title: '',
            content: '',
            created: ''
          }
        }
      },
      scrollable: {
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    data () {
      return {
        show: false,
        overlayStyle: {
          'background-color': 'rgba(255,255,255,1)'
        },
      }
    },
    computed: {
      createdFormat () {
        let created = ''
        if (this.noticeData.created) {
          created = this.noticeData.created.slice(0, 10)
        }
        return created
      }
    },
    methods: {
      expendNoticebar: function () {
        this.show = true
      },
      closePopup: function () {
        this.show = false
      }
    },
    watch: {},
    mounted () {
      // window.console.log(`scrollable found: ${this.scrollable}`)
    },
  }
</script>

<style lang="css" scoped>
  .container {
    /* padding: 16px; */
    color: #a3a3a4;
    font-size: 14px;
    /* margin: 10px 0; */
  }
  .inner-container {
    /* padding: 10px; */
    padding: 14px 16px;
    /* border: 1px solid #e7e7e7; */
    border: 1px solid #ebedf0;
    /* border-radius: 5px; */
    background: #fff;
  }
  .container .title, .popup-container .title {
    color: #141414;
    /* color: #228df6; */
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .title .date {
    color: #c7c7c7;
    margin-left: 8px;
    font-weight: normal;
  }
  .content {
    margin-top: 12px;
    white-space: pre-wrap;
  }
  .popup-container {
    padding: 15px 16px 16px 16px;
    background: #fff;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    font-size: 15px;
  }
</style>
